/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API17361Req {
  
  /**  */
  code: string;
    
};



export interface API17361Res {
  /** 登录成功返回的token  */
  userToken: string;
  /** 用户id  */
  userId: string;
  /** 是否是灰度用户  */
  beta: boolean;
  /** 是否切换为新平台  */
  isNewPlatform: boolean;
  /** 是否服务灰度  */
  isGray: boolean;
  /** 宕机起始时间  */
  breakDownStart: string;
  /** 宕机截止时间  */
  breakDownEnd: string;
  /** 宕机通告  */
  breakMessage: string;
  
};


// 17361 钉钉扫码登陆

export interface IUsePostAPI17361Return {
  /** 钉钉扫码登陆: 接口请求状态 */
  isAPI17361Loading: boolean;
  /** 钉钉扫码登陆: 接口请求返回数据 */
  dataAPI17361: API17361Res;
  /**  钉钉扫码登陆: 接口数据请求方法 */
  fetchAPI17361Data:  (inputs: API17361Req, config?: YWRequestConfig) => Promise<API17361Res>;
  /** 钉钉扫码登陆: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI17361 = ():IUsePostAPI17361Return => {
  let isMount = true;
  const [isAPI17361Loading, setIsAPI17361Loading] = useState(false);
  const [dataAPI17361, setDataAPI17361] = useState<API17361Res>({} as API17361Res);
  const requestUrl = `${basePath}/ywwl-admin/user/scan/login`;

  const fetchAPI17361Data = async (inputs: API17361Req, config?: YWRequestConfig): Promise<API17361Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API17361Req>) || {}) as API17361Req;
    
  
    if ( isMount ) {
      setIsAPI17361Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API17361Res>(`${basePath}/ywwl-admin/user/scan/login`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI17361(res || {} as API17361Res);
        setIsAPI17361Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI17361Loading(false);
      }
      return false as unknown as API17361Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI17361Loading,
    dataAPI17361,
    fetchAPI17361Data,
    requestUrl,
  }
}

